import UserFacilities from "./UserFacilities";
import UserCreditLayers from "./UserCreditLayers";

const DashboardLayout = () => {
	return (
		<>
			<UserCreditLayers />
			<UserFacilities />
		</>
	);
};
export default DashboardLayout;